import './SoriginSidebarBackdrop.css';

interface SoriginSidebarBackdropProps {
  className?: string;
}

export default function SoriginSidebarBackdrop({ className }: SoriginSidebarBackdropProps) {
  return (
    <svg
      className={`sorigin-sidebar-backdrop ${className ?? ''}`}
      width="100%"
      height="100%"
      viewBox="0 0 272 1000"
      preserveAspectRatio="xMidYMin slice"
      role="img"
      aria-hidden="true"
    >
      <defs>
        {/* gentle vertical surface tint — warm cream, Sovereign Emerald paper */}
        <linearGradient id="ssb-surface" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#F8F2E2" stopOpacity="0.85" />
          <stop offset="60%" stopColor="#F2EADB" stopOpacity="0.45" />
          <stop offset="100%" stopColor="#EFE5D2" stopOpacity="0.55" />
        </linearGradient>
      </defs>

      {/* surface tint */}
      <rect width="272" height="1000" fill="url(#ssb-surface)" />

      {/* hairline divider under the logo band (aligned with AppHeader bottom border) */}
      <line x1="0" y1="76" x2="272" y2="76" stroke="rgba(11,59,46,0.16)" strokeWidth="1" />
    </svg>
  );
}
